<template lang="pug">
.time-selector.border-top.border-bottom
  small.text-muted.pb-2.font-weight-bold {{ label || $t('Select Hour / Minute') }}
  .d-flex.align-items-center
    pr-select.flex-grow-1.text-center(:value.sync="hour", :options="optionsHour", :xsmall="xsmall", :small="small", :outline="outline")
    .seperator :
    pr-select.flex-grow-1.text-center(:value.sync="minute", :options="optionsMinute", :xsmall="xsmall", :small="small", :outline="outline")
</template>

<script>
const Props = {
  label: String,
  value: String,
  xsmall: Boolean,
  small: Boolean,
  outline: Boolean
}

export default {
  name: "pr-time-selector",
  props: {
    ...Props
  },
  data() {
    return {
      hour: "00",
      minute: "00",
      optionsHour: [
        "00",
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12",
        "13",
        "14",
        "15",
        "16",
        "17",
        "18",
        "19",
        "20",
        "21",
        "22",
        "23"
      ],
      optionsMinute: ["00", "15", "30", "45"]
    }
  },
  watch: {
    hour(nval) {
      this.$emit("update:value", `${nval}:${this.minute}`)
    },
    minute(nval) {
      this.$emit("update:value", `${this.hour}:${nval}`)
    }
  },
  mounted() {
    this.setHour()
    this.setMinute()
  },
  methods: {
    setHour() {
      if (this.value) {
        const _val = this.value.split(":")
        if (Array.isArray(_val) && _val.length) {
          this.hour = _$.pad(_val[0], "00")
          return
        }
      }

      const _date = new Date()
      this.hour = _$.pad(_date.getHours(), "00")
    },
    setMinute() {
      if (this.value) {
        const _val = this.value.split(":")
        if (Array.isArray(_val) && _val.length) {
          this.minute = _$.pad(_val[1], "00")
          return
        }
      }

      const _date = new Date()
      this.minute = _$.pad(_date.getMinutes(), "00")
    }
  }
}
</script>

<style lang="scss" scoped>
.time-selector {
  display: flex;
  flex-direction: column;

  .seperator {
    padding: 0 10px;
  }
}
</style>
